// src/com/file_of_report/ArrivalOnTimeReportGql.js
import { gql } from "@apollo/client";

/*

extend type Mutation {
    # 센터, 운송사 무관하게 사용.
    arrivalOnTimeReportAdd(arrivalOnTimeReport: InputArrivalOnTimeReportAdd!): ResponseWithFileCreateHisItem!
}

# 정시도착 레포트 조회용 입력. 운송사 여부에 따라 서비스 내에서 분기.
input InputArrivalOnTimeReportAdd {
    dateFrom: String!
    dateTill: String!
	dcCd: String
    transTypeCd: String
    vehTypeId: String
    comId: String
    storeId: String
    vehPlates: String
    reportForEvent: Boolean!
}

*/

export const CREATE_ARRIVAL_ON_TIME_REPORT = gql`
mutation CreateArrivalOnTimeReport($arrivalOnTimeReport:InputArrivalOnTimeReportAdd!) {
    arrivalOnTimeReportAdd(arrivalOnTimeReport: $arrivalOnTimeReport) {
        ok
        message
        item {
            fileCreateHisSeq
        }
    }
}
`;

